// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__6yrBi","logoIcon":"Logo_logoIcon__J9oRr","logoBlack":"Logo_logoBlack__OvWPY"};